module.exports = "<p>\n  playground-page works!\n</p>\n"